import React, { FC, useContext } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { ScheduledJobs } from '../ScheduledJobs/ScheduledJobs';
import { OrganizationScheduledProductsFetcher } from './CustomerFetchers';
import { useTranslation } from 'react-i18next';
import Box from '@mui/system/Box';
import { useEnumState } from '../../hooks/useEnumState';
import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import { styled } from '@mui/material';
import { useAutoFetch } from '../../contexts/Fetcher';

interface IProps {
  defaultExpanded?: boolean;
}

const StyledLink = styled(Link)({
  cursor: 'pointer',
});

export const OrganizationScheduledProducts: FC<IProps> = ({ defaultExpanded = true }) => {
  const { t } = useTranslation();
  const [isExpanded, expand] = useEnumState(defaultExpanded, true);

  useAutoFetch(OrganizationScheduledProductsFetcher);

  const { data: scheduledData, onRefresh: onScheduledRefresh } = useContext(
    OrganizationScheduledProductsFetcher.Context
  );

  if (!scheduledData?.length) return null;
  if (!isExpanded) {
    return (
      <Box mt={3} mb={3}>
        <Alert severity="info">
          There are some planned actions with your products. <StyledLink onClick={expand}>Click here</StyledLink> to
          learn more
        </Alert>
      </Box>
    );
  }

  return scheduledData && scheduledData.length > 0 ? (
    <Box mt={3} mb={3}>
      <Paper>
        <Typography variant="h4">
          <Box p={2}>{t('organization.products.scheduled')}</Box>
        </Typography>
        <Divider />
        <ScheduledJobs jobs={scheduledData} onRefresh={onScheduledRefresh} />
      </Paper>
    </Box>
  ) : null;
};
